export const resolveCardBrand = (type) => {
  switch (type) {
    case 'Visa':
      return 'visa';
    case 'Mastercard':
      return 'master';
    case 'American Express':
      return 'amex';
    case 'Elo':
      return 'elo';
    case 'Diners Club':
      return 'diners';
    case 'Discover':
      return 'discover';
    case 'Hipercard':
      return 'hipercard';
    case 'Hiper':
      return 'hiper';
    default:
      return type;
  }
};
